// // src/pages/ProfilePage.js
// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { formatDistanceToNow } from 'date-fns';
// import { useAuth } from '../contexts/AuthContext';
// import api from '../utils/api';
// import PostCard from '../components/posts/PostCard';
// import ProfileTabs from '../components/profile/ProfileTabs';
// import FollowButton from '../components/profile/FollowButton';
// import EditProfileModal from '../components/profile/EditProfileModal';
// import '../styles/profile-page.css';

// const ProfilePage = () => {
//   const { username } = useParams();
//   const { user } = useAuth();
//   const [profile, setProfile] = useState(null);
//   const [posts, setPosts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [activeTab, setActiveTab] = useState('posts');
//   const [showEditModal, setShowEditModal] = useState(false);
  
//   const isOwnProfile = user && user.username === username;
  
//   // Fetch profile data
//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         setLoading(true);
        
//         const response = await api.get(`/api/users/${username}`);
//         setProfile(response.data);
        
//         // Fetch posts if viewing posts tab
//         if (activeTab === 'posts') {
//           fetchUserPosts();
//         }
//       } catch (err) {
//         console.error('Error fetching profile:', err);
//         setError('Failed to load profile');
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchProfile();
//   }, [username]);
  
//   // Fetch user posts
//   const fetchUserPosts = async () => {
//     try {
//       const response = await api.get(`/api/users/${username}/posts`);
//       setPosts(response.data.posts);
//     } catch (err) {
//       console.error('Error fetching posts:', err);
//       setError('Failed to load posts');
//     }
//   };
  
//   // Handle tab change
//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
    
//     if (tab === 'posts') {
//       fetchUserPosts();
//     }
//     // For a real app, implement fetchFollowers and fetchFollowing
//   };
  
//   // Handle follow/unfollow
//   const handleFollowToggle = async () => {
//     try {
//       if (profile.isFollowing) {
//         await api.delete(`/api/follows/${username}`);
//       } else {
//         await api.post(`/api/follows/${username}`);
//       }
      
//       // Update profile state
//       setProfile({
//         ...profile,
//         isFollowing: !profile.isFollowing,
//         followers: profile.isFollowing ? profile.followers - 1 : profile.followers + 1
//       });
//     } catch (err) {
//       console.error('Error toggling follow:', err);
//     }
//   };
  
//   // Handle profile update
//   const handleProfileUpdate = (updatedProfile) => {
//     setProfile({ ...profile, ...updatedProfile });
//     setShowEditModal(false);
//   };

//   const getIMGURL = (url) => {
//     if (!url) return '/default-avatar.png';
    
//     if (url.startsWith('ipfs://')) {
//       // Extract the CID (Content ID) from the IPFS URL
//       const cid = url.replace('ipfs://', '');
//       // Use a public IPFS gateway
//       return `https://ipfs.io/ipfs/${cid}`;
//     }
    
//     return url;
//   }
  
//   if (loading) {
//     return <div className="loading">Loading profile...</div>;
//   }
  
//   if (error) {
//     return <div className="error-message">{error}</div>;
//   }
  
//   if (!profile) {
//     return <div className="error-message">User not found</div>;
//   }
  
//   // Format joined date
//   const joinedDate = new Date(profile.joinDate);
//   const formattedJoinDate = `Joined ${joinedDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}`;
  
//   return (
//     <div className="profile-page">
//       {/* Profile header */}
//       <div className="profile-header">
//         <div className="cover-photo">
//           {profile.coverPic && <img src={getIMGURL(profile.coverPic)} alt="Cover" />}
//         </div>
        
//         <div className="profile-header-content">
//           <div className="profile-avatar">
//             <img 
//               src={getIMGURL(profile.profilePic) || '/default-avatar.png'} 
//               alt={profile.username} 
//             />
//           </div>
          
//           <div className="profile-actions">
//             {isOwnProfile ? (
//               <button 
//                 className="edit-profile-button"
//                 onClick={() => setShowEditModal(true)}
//               >
//                 Edit Profile
//               </button>
//             ) : (
//               <FollowButton 
//                 isFollowing={profile.isFollowing} 
//                 onToggle={handleFollowToggle} 
//               />
//             )}
//           </div>
//         </div>
//       </div>
      
//       {/* Profile info */}
//       <div className="profile-info">
//         <h2 className="profile-name">
//           {profile.displayName || profile.username}
//         </h2>
//         <span className="profile-username">@{profile.username}</span>
        
//         {profile.bio && <p className="profile-bio">{profile.bio}</p>}
        
//         <div className="profile-meta">
//           {profile.location && (
//             <span className="profile-location">
//               <i className="location-icon">📍</i> {profile.location}
//             </span>
//           )}
          
//           {profile.website && (
//             <a 
//               href={profile.website.startsWith('http') ? profile.website : `https://${profile.website}`} 
//               className="profile-website"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <i className="website-icon">🔗</i> {profile.website}
//             </a>
//           )}
          
//           <span className="profile-joined">
//             <i className="calendar-icon">📅</i> {formattedJoinDate}
//           </span>
//         </div>
        
//         <div className="profile-stats">
//           <Link to={`/profile/${username}/following`} className="stat-item">
//             <span className="stat-value">{profile.following}</span>
//             <span className="stat-label">Following</span>
//           </Link>
          
//           <Link to={`/profile/${username}/followers`} className="stat-item">
//             <span className="stat-value">{profile.followers}</span>
//             <span className="stat-label">Followers</span>
//           </Link>
//         </div>
//       </div>
      
//       {/* Profile tabs */}
//       <ProfileTabs activeTab={activeTab} onTabChange={handleTabChange} />
      
//       {/* Profile content */}
//       <div className="profile-content">
//         {activeTab === 'posts' && (
//           <div className="profile-posts">
//             {posts.length > 0 ? (
//               posts.map(post => (
//                 <PostCard key={post.id} post={post} />
//               ))
//             ) : (
//               <div className="empty-state">
//                 <h3>No posts yet</h3>
//                 <p>When {isOwnProfile ? 'you post' : `${profile.username} posts`}, they will show up here.</p>
//               </div>
//             )}
//           </div>
//         )}
        
//         {activeTab === 'followers' && (
//           <div className="profile-followers">
//             {/* Followers list component would go here */}
//             <div className="empty-state">
//               <h3>Followers</h3>
//               <p>This section is under construction</p>
//             </div>
//           </div>
//         )}
        
//         {activeTab === 'following' && (
//           <div className="profile-following">
//             {/* Following list component would go here */}
//             <div className="empty-state">
//               <h3>Following</h3>
//               <p>This section is under construction</p>
//             </div>
//           </div>
//         )}
//       </div>
      
//       {/* Edit profile modal */}
//       {showEditModal && (
//         <EditProfileModal
//           profile={profile}
//           onSave={handleProfileUpdate}
//           onCancel={() => setShowEditModal(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default ProfilePage;










// src/pages/ProfilePage.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';
import PostCard from '../components/posts/PostCard';
import ProfileTabs from '../components/profile/ProfileTabs';
import FollowButton from '../components/profile/FollowButton';
import EditProfileModal from '../components/profile/EditProfileModal';
import UserListItem from '../components/profile/UserListItem';
import '../styles/profile-page.css';
import StatusViewer from '../components/profile/StatusViewer';
import StatusModal from '../components/profile/StatusModal';

const ProfilePage = () => {
  const { username } = useParams();
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [posts, setPosts] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('posts');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [hasStatus, setHasStatus] = useState(false);
  const [showViewer, setShowViewer] = useState(false);

  
  const isOwnProfile = user && user.username === username;
  
  // Fetch profile data
  useEffect(() => {
    setLoading(true);
    setError('');
    fetchProfile();
  }, [username]);
  
  // When tab changes, fetch appropriate data
  useEffect(() => {
    if (profile) {
      if (activeTab === 'posts') {
        fetchUserPosts();
      } else if (activeTab === 'followers') {
        fetchFollowers();
      } else if (activeTab === 'following') {
        fetchFollowing();
      }
    }
  }, [activeTab, profile]);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const res = await api.get(`/status/${profile.id}`);
        if (res.data.length > 0) setHasStatus(true);
      } catch (e) {
        console.error('Status check failed:', e);
      }
    };
    if (profile?.id) checkStatus();
  }, [profile?.id]);
  
  const fetchProfile = async () => {
    try {
      const response = await api.get(`/api/users/${username}`);
      setProfile(response.data);
      setLoading(false);
      
      // Fetch initial tab data
      if (activeTab === 'posts') {
        fetchUserPosts();
      }
    } catch (err) {
      console.error('Error fetching profile:', err);
      setError('Failed to load profile');
      setLoading(false);
    }
  };
  
  const fetchUserPosts = async () => {
    try {
      const response = await api.get(`/api/users/${username}/posts`);
      setPosts(response.data.posts);
    } catch (err) {
      console.error('Error fetching posts:', err);
      setError('Failed to load posts');
    }
  };
  
  const fetchFollowers = async () => {
    try {
      const response = await api.get(`/api/follows/${username}/followers`);
      setFollowers(response.data.followers);
    } catch (err) {
      console.error('Error fetching followers:', err);
      setError('Failed to load followers');
    }
  };
  
  const fetchFollowing = async () => {
    try {
      const response = await api.get(`/api/follows/${username}/following`);
      setFollowing(response.data.following);
    } catch (err) {
      console.error('Error fetching following:', err);
      setError('Failed to load following');
    }
  };
  
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  
  const handleFollowToggle = async () => {
    try {
      if (profile.isFollowing) {
        await api.delete(`/api/follows/${username}`);
      } else {
        await api.post(`/api/follows/${username}`);
      }
      
      // Update profile state with new follow status
      setProfile({
        ...profile,
        isFollowing: !profile.isFollowing,
        followers: profile.isFollowing ? profile.followers - 1 : profile.followers + 1
      });
    } catch (err) {
      console.error('Error toggling follow:', err);
    }
  };
  
  const handleProfileUpdate = (updatedProfile) => {
    setProfile({ ...profile, ...updatedProfile });
    setShowEditModal(false);
  };
  const openStatusViewer = () => setShowViewer(true);
  if (loading) {
    return <div className="loading">Loading profile...</div>;
  }
  
  if (error) {
    return <div className="error-message">{error}</div>;
  }
  
  if (!profile) {
    return <div className="error-message">User not found</div>;
  }
  
  // Format joined date
  const joinedDate = new Date(profile.joinDate);
  const formattedJoinDate = `Joined ${joinedDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}`;
  
  return (
    <div className="profile-page">
      {/* Profile header */}
      <div className="profile-header">
        <div className="cover-photo">
          {profile.coverPic && (
            <img 
              src={profile.coverPic.startsWith('ipfs://') 
                ? `https://ipfs.io/ipfs/${profile.coverPic.replace('ipfs://', '')}` 
                : profile.coverPic} 
              alt="Cover" 
            />
          )}
        </div>
        
        <div className="profile-header-content">
        <div className="profile-avatar" onClick={() => hasStatus && openStatusViewer()}>
          <div className={`avatar-ring-wrapper ${hasStatus ? 'active' : ''}`}>
            <img 
              src={profile.profilePic 
                ? (profile.profilePic.startsWith('ipfs://') 
                  ? `https://ipfs.io/ipfs/${profile.profilePic.replace('ipfs://', '')}` 
                  : profile.profilePic)
                : '/default-avatar.png'}
              alt={profile.username}
              className="avatar-img"
            />
          </div>
        </div>
          
          <div className="profile-actions">
            {isOwnProfile ? (
              <div>
                <button onClick={() => setShowStatusModal(true)}>Post Status</button>
                {showStatusModal && <StatusModal userId={user.id} onClose={() => setShowStatusModal(false)} onPosted={() => {}} /> }   
                <button 
                  className="edit-profile-button"
                  onClick={() => setShowEditModal(true)}
                >
                  Edit Profile
                </button>
              </div>
            ) : (
                <FollowButton 
                username={username}
                isFollowing={!!profile.isFollowing} // Force boolean with !!
                onToggle={handleFollowToggle} 
              />
            )}
          </div>
        </div>
      </div>
      
      {/* Profile info */}
      <div className="profile-info">
        <h2 className="profile-name">
          {profile.displayName || profile.username}
        </h2>
        <span className="profile-username">@{profile.username}</span>
        
        {profile.bio && <p className="profile-bio">{profile.bio}</p>}
        
        <div className="profile-meta">
          {profile.location && (
            <span className="profile-location">
              <i className="location-icon">📍</i> {profile.location}
            </span>
          )}
          
          {profile.website && (
            <a 
              href={profile.website.startsWith('http') ? profile.website : `https://${profile.website}`} 
              className="profile-website"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="website-icon">🔗</i> {profile.website}
            </a>
          )}
          
          <span className="profile-joined">
            <i className="calendar-icon">📅</i> {formattedJoinDate}
          </span>
        </div>
        
        <div className="profile-stats">
          <button 
            className={`stat-item ${activeTab === 'following' ? 'active' : ''}`}
            onClick={() => setActiveTab('following')}
          >
            <span className="stat-value">{profile.following}</span>
            <span className="stat-label">Following</span>
          </button>
          
          <button 
            className={`stat-item ${activeTab === 'followers' ? 'active' : ''}`}
            onClick={() => setActiveTab('followers')}
          >
            <span className="stat-value">{profile.followers}</span>
            <span className="stat-label">Followers</span>
          </button>
        </div>
      </div>
      
      {/* Profile tabs */}
      <ProfileTabs activeTab={activeTab} onTabChange={handleTabChange} />
      
      {/* Profile content */}
      <div className="profile-content">
        {activeTab === 'posts' && (
          <div className="profile-posts">
            {posts.length > 0 ? (
              posts.map(post => (
                <PostCard key={post.id} post={post} />
              ))
            ) : (
              <div className="empty-state">
                <h3>No posts yet</h3>
                <p>When {isOwnProfile ? 'you post' : `${profile.username} posts`}, they will show up here.</p>
              </div>
            )}
          </div>
        )}
        
        {activeTab === 'followers' && (
          <div className="profile-followers">
            {followers.length > 0 ? (
              followers.map(follower => (
                <UserListItem 
                  key={follower.username} 
                  user={follower} 
                  currentUsername={user?.username}
                />
              ))
            ) : (
              <div className="empty-state">
                <h3>No followers yet</h3>
                <p>{isOwnProfile ? 'You don\'t have' : `${profile.username} doesn't have`} any followers yet.</p>
              </div>
            )}
          </div>
        )}
        
        {activeTab === 'following' && (
          <div className="profile-following">
            {following.length > 0 ? (
              following.map(followed => (
                <UserListItem 
                  key={followed.username} 
                  user={followed}
                  currentUsername={user?.username}
                />
              ))
            ) : (
              <div className="empty-state">
                <h3>Not following anyone</h3>
                <p>{isOwnProfile ? 'You aren\'t' : `${profile.username} isn't`} following anyone yet.</p>
              </div>
            )}
          </div>
        )}
      </div>
      
      {/* Edit profile modal */}
      {showEditModal && (
        <EditProfileModal
          profile={profile}
          onSave={handleProfileUpdate}
          onCancel={() => setShowEditModal(false)}
        />
      )}
      {showViewer && (
        <StatusViewer userId={profile.id} onClose={() => setShowViewer(false)} />
      )}
    </div>
  );
};

export default ProfilePage;